module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default; 
    ; __append("\r\n\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\" style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px;\r\n        width: auto; height: auto;\r\n        z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n    <div class=\"size-handle-top\" style=\"width: 100%;\"></div>\r\n\r\n\r\n        <div class=\"pf-control-core pf-selectable\" style=\"\r\n                align-items : center;\r\n                height: ")
    ; __append(escapeFn( u.extractNum(height) + 3 ))
    ; __append("px;\r\n                width: auto;\r\n                -webkit-border-radius: 0px;\r\n                -moz-border-radius: 0px;\r\n                border: ")
    ; __append(escapeFn(borderSize))
    ; __append("px ")
    ; __append(escapeFn(borderStyle))
    ; __append(" ")
    ; __append(escapeFn(borderColor))
    ; __append(";\r\n                border-radius: ")
    ; __append(escapeFn(cornerRadius))
    ; __append("px;\r\n                font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n                font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px;\r\n                font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append(";\r\n                font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n                color: ")
    ; __append(escapeFn(styleColorText))
    ; __append(";\r\n                background-color: ")
    ; __append(escapeFn(backgroundColor))
    ; __append("; overflow: hidden;\">\r\n            <div style=\"display: inline-flex; margin: 1px auto;\">\r\n                ")
    ; 

                    var itemStyle = "display: inline-flex; margin: 0 2px; justify-content: center; align-items: center;";
                    mask.split('').forEach( function( item ) {
                        var style = itemStyle + (((item !== '-') && (item !== '(') && (item!==')')) ? "color: transparent;background-color: #cccccc;" : ""); 
    ; __append("\r\n                        <label style=\"width:")
    ; __append(escapeFn(widthItem))
    ; __append("px;height: ")
    ; __append(escapeFn(heightItem))
    ; __append("px;")
    ; __append(escapeFn( style ))
    ; __append("\">")
    ; __append(escapeFn( item ))
    ; __append("</label>\r\n                    ")
    ;  });
    ; __append("\r\n            </div>\r\n        </div>\r\n\r\n    <div class=\"size-handle-bottom\" style=\"width: 100%;\"></div>\r\n</div>")
  }
  return __output;

}